document.addEventListener("DOMContentLoaded", () => {

    /*====================================================
      CONFIGURADOR (Página del Room Finder)
    ====================================================*/

    const roomFinder = document.querySelector(".room-finder");

    if (roomFinder) {

        const sizeButtons = roomFinder.querySelectorAll(".rf-size");
        const colorButtons = roomFinder.querySelectorAll(".rf-color");
        const searchButton = roomFinder.querySelector("#rf-search-btn");

        let selectedSize = "";
        let selectedColor = "";

        /*=====================
            TAMAÑOS
        =====================*/

        sizeButtons.forEach(button => {

            button.addEventListener("click", () => {

                sizeButtons.forEach(btn => {

                    btn.style.background = "#fff";
                    btn.style.color = "#222";
                    btn.style.borderColor = "#ddd";

                });

                button.style.background = "#222";
                button.style.color = "#fff";
                button.style.borderColor = "#222";

                selectedSize = button.dataset.filter;

            });

        });

        /*=====================
            COLORES
        =====================*/

        colorButtons.forEach(button => {

            button.addEventListener("click", () => {

                colorButtons.forEach(btn => {

                    btn.style.border = "2px solid transparent";
                    btn.style.transform = "scale(1)";

                });

                button.style.border = "3px solid #111";
                button.style.transform = "scale(1.1)";

                selectedColor = button.dataset.filter;

            });

        });

        /*=====================
            BOTÓN BUSCAR
        =====================*/

        searchButton.addEventListener("click", (e) => {

            e.preventDefault();

            if (!selectedSize) {

                alert("Selecciona el tamaño de tu sala.");

                return;

            }

            if (!selectedColor) {

                alert("Selecciona un color.");

                return;

            }

            const baseUrl = searchButton.dataset.collection;

            const params = new URLSearchParams();

            /* Datos del Room Finder */
            params.set("rf", "1");
            params.set("rf_size", selectedSize);
            params.set("rf_color", selectedColor);

            /* Filtros Shopify */
            params.set("filter.v.price.gte", "");
            params.set("filter.v.price.lte", "");
           params.set(searchButton.dataset.sizeFilter, selectedSize);
params.set(searchButton.dataset.colorFilter, selectedColor);

            params.set("sort_by", "manual");
            params.set("view", "grid");

            window.location.href = `${baseUrl}?${params.toString()}`;

        });

    }


const colorsContainer = document.querySelector(".rf-colors");

if (colorsContainer) {

    colorsContainer.addEventListener("wheel", function (e) {

        if (e.deltaY !== 0) {

            e.preventDefault();

            this.scrollLeft += e.deltaY;

        }

    }, { passive: false });

}

const colors = document.querySelector(".rf-colors");

const prev = document.querySelector(".rf-arrow-prev");

const next = document.querySelector(".rf-arrow-next");

if (colors && prev && next){

    prev.addEventListener("click", () => {

        colors.scrollBy({

            left:-180,

            behavior:"smooth"

        });

    });

    next.addEventListener("click", () => {

        colors.scrollBy({

            left:180,

            behavior:"smooth"

        });

    });

}

function updateColorArrows() {

    const maxScroll = colors.scrollWidth - colors.clientWidth;

    prev.style.visibility = colors.scrollLeft <= 5 ? "hidden" : "visible";

    next.style.visibility = colors.scrollLeft >= maxScroll - 5 ? "hidden" : "visible";

}

colors.addEventListener("scroll", updateColorArrows);

window.addEventListener("resize", updateColorArrows);

updateColorArrows();
});